import React from "react";
import { FaInstagramSquare, FaWhatsappSquare, FaEnvelope, FaPhone } from "react-icons/fa";

import styles from "../Footer.module.scss";

const email = "stepforma@nextopinion.com.pt";
const telefone = "+55 1199609-1683";
const instagram = "https://www.instagram.com/stepformaedu/";
const whatsapp = "https://api.whatsapp.com/send?phone=+55 1199609-1683&text=Eu tenho interesse em aderir &agrave; Stepforma";

const Contactos = () => (
    <>
        <span>
            <span className={styles.contactsTitle}>Social</span>
            <ul>
                <li>
                    <a href={instagram} target="_blank" rel="noopener noreferrer" title="Instagram">
                        <FaInstagramSquare />
                        Instagram
                    </a>
                </li>
                <li>
                    <a href={whatsapp} target="_blank" rel="noopener noreferrer" title="Whatsapp">
                        <FaWhatsappSquare />
                        Whatsapp
                    </a>
                </li>
            </ul>
        </span>
        <span>
            <span className={styles.contactsTitle}>Contato</span>
            <ul>
                <li>
                    <a href={`mailto:${email}`} className={styles.contactsSmallerIcon} rel="noopener noreferrer" title="E-mail">
                        <FaEnvelope />
                        {email}
                    </a>
                </li>
                <li>
                    <a
                        href="#"
                        className={styles.contactsSmallerIcon}
                        rel="noopener noreferrer"
                        title="Telefone"
                        style={{ cursor: "default" }}
                    >
                        <FaPhone />
                        {telefone}
                    </a>
                </li>
            </ul>
        </span>
    </>
);

export default Contactos;
